/*
  NO2MORO GLOBAL EURO PRICE FORMATTER V1

  Storefront display rules:
  €64,00      -> €64
  €64.00      -> €64
  €44,50      -> €44.50
  €44.50      -> €44.50
  €1.234,50   -> €1,234.50
  €1,234.50   -> €1,234.50

  This formats visible storefront text only. It does not alter Shopify's
  underlying numeric prices, cart calculations, checkout values or APIs.
*/

(() => {
  if (window.__no2moroGlobalEuroPriceFormatterV1) return;
  window.__no2moroGlobalEuroPriceFormatterV1 = true;

  const ignoredTags = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'INPUT'
  ]);

  const formatEuroText = (value) => {
    if (!value || !value.includes('€')) return value;

    return value.replace(
      /€(?:\s|\u00A0)?(\d[\d.,\s\u00A0]*\d|\d)/g,
      (match, rawAmount) => {
        let amount = rawAmount.replace(/[\s\u00A0]/g, '');
        let integerPart = amount;
        let decimalPart = '';

        const commaIndex = amount.lastIndexOf(',');
        const dotIndex = amount.lastIndexOf('.');
        const decimalIndex = Math.max(commaIndex, dotIndex);

        if (
          decimalIndex > -1 &&
          amount.length - decimalIndex - 1 === 2
        ) {
          integerPart = amount.slice(0, decimalIndex);
          decimalPart = amount.slice(decimalIndex + 1);
        }

        integerPart = integerPart.replace(/[.,]/g, '');

        if (!/^\d+$/.test(integerPart)) {
          return match;
        }

        const formattedInteger = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        );

        if (decimalPart === '' || decimalPart === '00') {
          return `€${formattedInteger}`;
        }

        return `€${formattedInteger}.${decimalPart}`;
      }
    );
  };

  // British customers see whole-pound merchandise prices without .00.
  // Non-zero pence (e.g. £6.95 postage) remain unchanged.
  const gbMarket = String(window.No2moroRegionalPricingConfig?.country ||
    window.Shopify?.country || '').toUpperCase() === 'GB';
  const formatGBP = text => !gbMarket ? text :
    text.replace(/£\s*(\d{1,3}(?:,\d{3})+|\d+)\.00(?!\d)/g, '£$1');

  const shouldIgnoreTextNode = (node) => {
    const parent = node && node.parentElement;

    if (!parent) return true;

    if (ignoredTags.has(parent.tagName)) return true;

    return Boolean(
      parent.closest(
        'script, style, noscript, textarea, input, [data-no2moro-price-format-ignore]'
      )
    );
  };

  const formatTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    if (shouldIgnoreTextNode(node)) return;
    if (!node.nodeValue ||
        (!node.nodeValue.includes('€') && (!gbMarket || !node.nodeValue.includes('£')))) return;

    const formatted = formatGBP(formatEuroText(node.nodeValue));

    if (formatted !== node.nodeValue) {
      node.nodeValue = formatted;
    }
  };

  const formatRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root !== document
    ) {
      return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (shouldIgnoreTextNode(node)) {
            return NodeFilter.FILTER_REJECT;
          }

          return node.nodeValue &&
            (node.nodeValue.includes('€') || (gbMarket && node.nodeValue.includes('£')))
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(formatTextNode);
  };

  const initialise = () => {
    formatRoot(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          formatTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          formatRoot(node);
        });
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        formatRoot(event.target);
      }
    );

    window.addEventListener(
      'pageshow',
      () => {
        requestAnimationFrame(() => {
          formatRoot(document.body);
        });
      },
      { passive: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise,
      { once: true }
    );
  } else {
    initialise();
  }
})();